import React from "react";

import Gallery4 from "../components/gallery/gallery4";
import MediaViewer from "../components/media-viewer/media-viewer";

import { ModalContext } from "../components/modal/modal";

import HttpService from "../services/http.service";

import config from "../config/config";
import { acceptedMediaExtensions } from "../models/models";

const GalleryPage: React.FC<any> = (props: any) => {

  const [mediaFileList, setMediaFileList] = React.useState<string[]>([]);
  const [busy, setBusy] = React.useState<boolean>(false);

  const modalContext = React.useContext(ModalContext);
  
  React.useEffect(() => {
    (async () => {
      setBusy(true);
      const res = await HttpService.get<string[]>('medialist');
      if (res.success && res.body) {
        setBusy(false);
        setMediaFileList(res.body.filter(filename => acceptedMediaExtensions.image.filter(accepted => filename.toLowerCase().endsWith(accepted)).length || acceptedMediaExtensions.video.filter(accepted => filename.toLowerCase().endsWith(accepted)).length));
      } 
    })();
  }, [])

  return (
    <div className="pt-16 diamonds">
      <h1 className="text-xl gold-text text-center align-middle inline-block ml-2 md:ml-8 mt-16">
          &nbsp;&nbsp;Media Gallery&nbsp;&nbsp;
      </h1>
      <div className=" min-h-screen  mx-auto">

        {
          busy && (
            <div className="flex justify-center items-center h-screen -my-24">
                <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
          )
        }
        { (!busy && mediaFileList.length) && (
          <Gallery4 maxColumnWidth={288} maxColumns={6}>
            {
              mediaFileList.map(a => (
                <span key={a} className="inline-block relative my-[1px] mx-[1px]">
                  {
                    acceptedMediaExtensions.image.filter(accepted => a.toLowerCase().endsWith(accepted)).length ?
                      <img
                        loading={"lazy"}
                        className="inline-block cursor-pointer m-0 p-0" 
                        src={
                          (
                            a.toUpperCase().startsWith('HTTP://') ||
                            a.toUpperCase().startsWith('HTTPS://') ||
                            a.toUpperCase().startsWith('WWW.')
                          ) ?
                            a
                          :
                            config.ASSETS[config.ENVIRONMENT] + 'media/' + a
                        }
                        onClick={() => {
                          (new Promise<any>((res, rej) => {
                            modalContext.modal!({
                              node: (<MediaViewer filename={'media/' + a}/>), 
                              resolve: res, 
                              reject: rej
                            });
                          })).then(result => {
                            modalContext.modal!();
                          }).catch(err => {});
                        }}
                      >
                      </img>
                    :
                      <video
                        playsInline webkit-playsInline webkit-playsinline controlsList="nodownload"
                        className='cursor-pointer -mb-2 p-0'
                        src={
                          (
                            a.toUpperCase().startsWith('HTTP://') ||
                            a.toUpperCase().startsWith('HTTPS://') ||
                            a.toUpperCase().startsWith('WWW.')
                          ) ?
                            a
                          :
                            config.ASSETS[config.ENVIRONMENT] + 'media/' + a + `#t=0.1`
                        }
                        autoPlay={false} muted={true} loop={true} preload="metadata"
                        onClick={() => {
                          (new Promise<any>((res, rej) => {
                            modalContext.modal!({
                              node: (<MediaViewer filename={'media/' + a}/>), 
                              resolve: res, 
                              reject: rej
                            });
                          })).then(result => {
                            modalContext.modal!();
                          }).catch(err => {});
                        }}
                      ></video>
                  }
                </span>
              ))
            }
          </Gallery4>
        )}

      </div>
    </div>
  )
}

export default GalleryPage;